import type { ComponentType } from 'react';
import type { Control, FieldValues } from 'react-hook-form';

export interface RegisteredCellProps {
  value: any;
  row: any;
}

export interface RegisteredFieldProps {
  name: string;
  control: Control<FieldValues>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  mode: 'create' | 'edit' | 'view';
  /** Id do registro aberto (ausente na criação). */
  recordId?: string;
}

export const cellComponentRegistry: Record<
  string,
  ComponentType<RegisteredCellProps>
> = {};
export const fieldComponentRegistry: Record<
  string,
  ComponentType<RegisteredFieldProps>
> = {};

/** Escape hatch: registra um renderer de célula custom, referenciável por `component: "<key>"` na screen. */
export function registerCellComponent(
  key: string,
  component: ComponentType<RegisteredCellProps>,
) {
  cellComponentRegistry[key] = component;
}

/** Escape hatch: registra um campo de formulário custom, referenciável por `component: "<key>"` na screen. */
export function registerFieldComponent(
  key: string,
  component: ComponentType<RegisteredFieldProps>,
) {
  fieldComponentRegistry[key] = component;
}
